import React, {Component} from "react";
import './index.css'
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import Select from "../../../Components/Control/Select";
import {connect} from "react-redux";
import Resource from "../../../Resource";
import PropTypes from 'prop-types'
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import Configuration from "../../../Server/Configuration";
import Separator from "../../../Components/Control/Separator";
import File from "../../../Components/Control/File";

class ModalUser extends Component {
    constructor(props) {
        super(props);

        props.refer.current = this;

        this.state = {
            title: {
                INSERT: 'افزودن کاربر',
                UPDATE: 'ویرایش کاربر',
                VIEW: 'اطلاعات کاربر'
            },
            hospitals: [{id: '', text: '...'}],
            roles: [],
            genders: [{id: '', text: '...'},
                ...props.base.genders.map(item => {
                    return {id: item.id, text: item.name};
                })],
            fields: {},
            error: false,
            loadingSections: false,
            loadingRoles: false
        };

        this.ref = {
            modal: React.createRef(),
            insert: React.createRef(),
            update: React.createRef(),
            close: React.createRef(),
            provinceId: React.createRef(),
            cityId: React.createRef(),
            hospitalId: React.createRef(),
            sectionId: React.createRef(),
            username: React.createRef(),
            password: React.createRef(),
            firstName: React.createRef(),
            lastName: React.createRef(),
            nationalCode: React.createRef(),
            genderID: React.createRef(),
            mobileNumber: React.createRef(),
            phoneNumber: React.createRef(),
            email: React.createRef(),
            address: React.createRef(),
            roleList: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        // provinceId: x => Boolean(x && x[0].id) || 'استان انتخاب نشده است.',
        // cityId: x => Boolean(x && x[0].id) || 'شهر انتخاب نشده است.',
        // hospitalId: x => Boolean(x && x[0]?.id) || 'بیمارستان انتخاب نشده است.',
        username: x => Boolean(x) || 'نام کاربری وارد نشده است.',
        password: x => Boolean(x) || this.state.action === ModalAction.UPDATE || 'رمزعبور وارد نشده است.',
        firstName: x => Boolean(x) || 'نام وارد نشده است.',
        lastName: x => Boolean(x) || 'نام خانوادگی وارد نشده است.',
        genderID: x => Boolean(x && x[0]?.id) || 'جنسیت انتخاب نشده است.',
        roleList: x => Boolean(x && x[0]?.id) || 'نقش کاربر انتخاب نشده است.',
    };

    componentDidMount() {


        this.loadingSections();
        this.loadingRoles();
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.fields !== nextState.fields ||
            state.hospitals !== nextState.hospitals ||
            state.loadingSections !== nextState.loadingSections ||
            state.loadingRoles !== nextState.loadingRoles ||
            state.roles !== nextState.roles;
    }

    render() {
        const {state, props} = this;
        const {fields} = state;
        const provinces = [
            {id: '', text: '...'},
            ...props.base.provinceCities.map(item => ({
                id: item.provinceId,
                text: item.provinceName,
                cities: (item.cities || []).map(item => ({
                    id: item.cityId,
                    text: item.cityName
                }))
            }))
        ];
        const cities = [
            {id: '', text: '...'},
            ...(fields.provinceId?.[0]?.cities || [])
        ];
        const sections = [
            {id: '', text: '...'},
            ...(state.fields?.hospitalId?.[0]?.sections || [])
        ];

        let readOnly = state.action === ModalAction.VIEW;

        return <Modal ref={this.ref.modal}
                      name={'ModalUser'}
                      size={'medium'}
                      title={state.title[state.action]}
                      error={state.error}
                      loading={(state.loadingSections || state.loadingRoles) ? 'در حال دریافت اطلاعات' : false}>
            <ModalContent>
                <div className={'dis-f'}>
                    <Input ref={this.ref.firstName} value={state.fields?.firstName} className={'pad-4 fb-4 fb-3x-8 fb-2x-20'} label={'نام'} readOnly={readOnly} validation={this.validations.firstName} onChange={this.field.bind(this, 'firstName')}/>
                    <Input ref={this.ref.lastName} value={state.fields?.lastName} className={'pad-4 fb-7 fb-3x-12 fb-2x-20'} label={'نام خانوادگی'} readOnly={readOnly} validation={this.validations.lastName} onChange={this.field.bind(this, 'lastName')}/>
                    <Input type={'number'} ref={this.ref.nationalCode} value={state.fields?.nationalCode} className={'pad-4 fb-5 fb-3x-10 fb-2x-20'} label={'کدملی'} readOnly={readOnly} onChange={this.field.bind(this, 'nationalCode')}/>
                    <Select ref={this.ref.genderID} value={state.fields?.genderID} options={state.genders} className={'pad-4 fb-4 fb-3x-10 fb-2x-20'} label={'جنسیت'} readOnly={readOnly} validation={this.validations.genderID} onChange={this.field.bind(this, 'genderID')}/>
                    <Input ref={this.ref.mobileNumber} value={state.fields?.mobileNumber} className={'pad-4 fb-5 fb-3x-10 fb-2x-20'} label={'شماره موبایل'} readOnly={readOnly} onChange={this.field.bind(this, 'mobileNumber')}/>
                    <Input ref={this.ref.phoneNumber} value={state.fields?.phoneNumber} className={'pad-4 fb-5 fb-3x-10 fb-2x-20'} label={'شماره تلفن'} readOnly={readOnly} onChange={this.field.bind(this, 'phoneNumber')}/>
                    <Input ref={this.ref.email} value={state.fields?.email} className={'pad-4 fb-10 fb-3x-20'} label={'آدرس ایمیل'} readOnly={readOnly} onChange={this.field.bind(this, 'email')}/>
                    <Input ref={this.ref.address} value={state.fields?.address} className={'pad-4 fb-20'} label={'آدرس'} readOnly={readOnly} onChange={this.field.bind(this, 'address')}/>
                    <Separator/>
                    <Select ref={this.ref.provinceId} value={state.fields?.provinceId} options={provinces} className={'pad-4 fb-10 fb-2x-20'} label={'استان'} readOnly={readOnly} onChange={this.field.bind(this, 'provinceId')}/>
                    <Select ref={this.ref.cityId} value={state.fields?.cityId} options={cities} className={'pad-4 fb-10 fb-2x-20'} label={'شهر'} readOnly={readOnly} onChange={this.field.bind(this, 'cityId')}/>
                    <Select ref={this.ref.hospitalId} value={state.fields?.hospitalId} options={state.hospitals} className={'pad-4 fb-10 fb-2x-20'} label={'نام بیمارستان'} readOnly={readOnly} onChange={this.field.bind(this, 'hospitalId')}/>
                    <Select ref={this.ref.sectionId} value={state.fields?.sectionId} options={sections} className={'pad-4 fb-10 fb-2x-20'} label={'نام بخش'} readOnly={readOnly} onChange={this.field.bind(this, 'sectionId')}/>
                    <Input ref={this.ref.username} value={state.fields?.username} className={'pad-4 fb-7 fb-3x-10 fb-2x-20'} label={'نام کاربری'} readOnly={readOnly} validation={this.validations.lastName} onChange={this.field.bind(this, 'username')}/>
                    <Input type={"password"} ref={this.ref.password} value={state.fields?.password} className={'pad-4 fb-6 fb-3x-10 fb-2x-20'} label={'رمزعبور'} readOnly={readOnly} validation={this.validations.password} onChange={this.field.bind(this, 'password')}/>
                    <Select ref={this.ref.roleList} value={state.fields?.roleList} multiple={true} options={state.roles} className={'pad-4 fb-7 fb-3x-20'} label={'نقش کاربر'} readOnly={readOnly} validation={this.validations.roleList} onChange={this.field.bind(this, 'roleList')}/>
                    <File className={'pad-4 fb-20'} label={'فایل امضا کاربر را انتخاب کنید.'} format={['image/*']} onChange={this.field.bind(this, 'image')}/>
                </div>
            </ModalContent>
            <ModalControls>
                {state.action === ModalAction.UPDATE && <Button className={'mar-4'} theme={'green'} icon={Resource.IMAGE.PACK.FILE.WHITE} onClick={this.view.bind(this)}>دریافت فایل</Button>}
                {state.action === ModalAction.INSERT && <Button refer={this.ref.insert} className={'mar-4'} theme={'blue'} onClick={this.insertClickHandler.bind(this)}>افزودن کاربر</Button>}
                {state.action === ModalAction.UPDATE && <Button refer={this.ref.update} className={'mar-4'} theme={'yellow'} onClick={this.updateClickHandler.bind(this)}>ویرایش کاربر</Button>}
                <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
            </ModalControls>
        </Modal>;
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    field(key, value) {
        const fields = {...this.state.fields};

        fields[key] = value;
        if (key === 'hospitalId') {
            delete fields['sectionId'];
        }

        this.setState({fields});
    }

    insertClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.insert.current.loading();
            this.setState({error: null});

            Configuration.addUser({
                provinceId: state.fields?.provinceId?.[0]?.id || null,
                cityId: state.fields?.cityId?.[0]?.id || null,
                hospitalId: state.fields?.hospitalId?.[0]?.id || null,
                sectionId: state.fields?.sectionId?.[0]?.id || null,
                username: state.fields?.username,
                password: state.fields?.password,
                firstName: state.fields?.firstName,
                lastName: state.fields?.lastName,
                nationalCode: state.fields?.nationalCode || null,
                genderID: state.fields?.genderID[0]?.id,
                mobileNumber: state.fields?.mobileNumber,
                phoneNumber: state.fields?.phoneNumber,
                email: state.fields?.email,
                address: state.fields?.address,
                status: 1,
                roleList: state.fields?.roleList.map(item => item.id),
                image: state.fields?.image?.[0]
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();

                ref.insert.current.loading(false);
                this.close(true);
            }).catch(message => {
                ref.insert.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    loadingRoles() {
        if (this.state.roles.length <= 1) {
            this.setState({loadingRoles: true});

            Configuration.rolesList()
                .then(list => {
                    this.setState({
                        roles: list.map(item => {
                            return {id: item.roleId, text: item.roleStr};
                        }),
                        loadingRoles: false
                    });
                })
                .catch(message => {
                    new Notif({message, theme: 'error'}).show();
                    this.ref.modal.current.close();
                    this.setState({loadingRoles: false});
                });
        }
    }

    loadingSections() {
        if (this.state.hospitals.length <= 1) {
            this.setState({loadingSections: true});

            Configuration.sectionsList()
                .then(list => {
                    const hospitals = {};

                    for (let item of list) {
                        if (!hospitals[item.hospitalId]) {
                            hospitals[item.hospitalId] = {
                                id: item.hospitalId,
                                text: item.hospitalFullName,
                                sections: []
                            };
                        }

                        hospitals[item.hospitalId].sections.push({id: item.sectionId, text: item.sectionName});
                    }

                    this.setState({
                        hospitals: [{id: '', text: '...', sections: []},
                            ...Object.values(hospitals)],
                        loadingSections: false
                    });
                })
                .catch(message => {
                    new Notif({message, theme: 'error'}).show();
                    this.ref.modal.current.close();
                    this.setState({loadingSections: false});
                });
        }
    }

    open(data, action) {
        if (action === ModalAction.INSERT) {
            this.setState({
                data,
                action,
                fields: {},
                error: null
            });
        } else if ([ModalAction.VIEW, ModalAction.UPDATE].includes(action)) {
            // eslint-disable-next-line eqeqeq
            const sections = this.state.hospitals.find(item => item.id === data.hospitalId)?.sections || [];

            this.setState({
                data,
                action,
                fields: {
                    userId: data.userId,
                    hospitalId: [{id: data.hospitalId, text: data.hospitalFullName, sections, forced: true}],
                    sectionId: [{id: data.sectionId, text: data.sectionStr, forced: true}],
                    username: data.userName,
                    password: null,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    nationalCode: data.nationalCode,
                    genderID: [{id: data.genderID}],
                    mobileNumber: data.mobileNumber,
                    phoneNumber: data.phoneNumber,
                    email: data.email,
                    address: data.address,
                    roleList: data?.userRolesVM ? data?.userRolesVM.map(item => {
                        return {id: item.roleId, text: item.roleStr};
                    }) : null,
                    status: 1
                },
                error: null
            });
        }

        return this.ref.modal.current.open();
    }

    updateClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.update.current.loading();
            this.setState({error: null});

            Configuration.updateUser({
                userId: state.fields?.userId,
                provinceId: state.fields?.provinceId?.[0]?.id || null,
                cityId: state.fields?.cityId?.[0]?.id || null,
                hospitalId: state.fields?.hospitalId?.[0]?.id || null,
                sectionId: state.fields?.sectionId?.[0]?.id || null,
                username: state.fields?.username,
                password: state.fields?.password || null,
                firstName: state.fields?.firstName,
                lastName: state.fields?.lastName,
                nationalCode: state.fields?.nationalCode,
                genderID: state.fields?.genderID[0]?.id,
                mobileNumber: state.fields?.mobileNumber,
                phoneNumber: state.fields?.phoneNumber,
                email: state.fields?.email,
                address: state.fields?.address,
                roleList: state.fields?.roleList.map(item => item.id),
                status: state.fields?.status,
                image: state.fields?.image?.[0]
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.UPDATE_SUCCESSFUL).show();

                ref.update.current.loading(false);
                this.close(true);
            }).catch(message => {
                ref.update.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    view() {
        const {state} = this;

        window.open(state.data.signatureAddress);
    }

    validate() {
        const validate = Tool.validate(
            this.ref.firstName,
            this.ref.lastName,
            this.ref.genderID,
            this.ref.username,
            this.ref.password,
            this.ref.roleList);

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base
    };
};

export default connect(mapStateToProps)(ModalUser);